import React from "react";
import { format } from "date-fns";

const TYPE_LABEL = {
  MEETING: "Meeting",
  APPOINTMENT: "Appointment",
  PRESENTATION: "Presentation",
  EVENT: "Event",
};

function formatRange(startISO, endISO) {
  const start = new Date(startISO);
  const end = new Date(endISO);
  const s = format(start, "h:mm a", { timeZone: "Asia/Kolkata" }).toLowerCase();
  const e = endISO ? format(end, "h:mm a", { timeZone: "Asia/Kolkata" }).toLowerCase() : "";
  return e ? `${s} – ${e}` : s;
}

export default function DayEventsModal({ 
  isOpen, 
  onClose, 
  events, 
  date, 
  onEventClick 
}) {
  if (!isOpen) return null;

  const sortedEvents = [...events].sort((a, b) => {
    // Important events first
    const aImportant = a.importance === true || a.importance === "important";
    const bImportant = b.importance === true || b.importance === "important";
    if (aImportant && !bImportant) return -1;
    if (bImportant && !aImportant) return 1;
    // Then by start time
    return new Date(a.start) - new Date(b.start);
  });

  const handleCardClick = (ev) => {
    onEventClick(ev);
    onClose();
  };

  return (
    <div className="day-events-modal-overlay" onClick={onClose}>
      <div className="day-events-modal" onClick={(e) => e.stopPropagation()}>
        <div className="day-events-modal-head">
          <h3 className="day-events-modal-title">
            {date ? format(date, "EEEE, MMMM d, yyyy") : "Events"}
          </h3>
          <button className="btn-icon" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <div className="day-events-modal-list">
          {sortedEvents.length === 0 ? (
            <div className="day-events-modal-empty">
              No events scheduled for this day
            </div>
          ) : (
            sortedEvents.map((ev) => (
              <div
                key={ev.id}
                className={`day-events-modal-card ${ev.importance === true || ev.importance === "important" ? "is-important" : ""}`}
                onClick={() => handleCardClick(ev)}
              >
                <div className="day-events-modal-cardhead">
                  <div className="day-events-modal-cardtitle">
                    {(ev.importance === true || ev.importance === "important") && (
                      <span className="chip chip--important">Important ★</span>
                    )}
                    {ev.title}
                  </div>
                  <div className="day-events-modal-cardtime">
                    {formatRange(ev.start, ev.end)}
                  </div>
                </div>
                <div className="day-events-modal-cardtype">
                  {TYPE_LABEL[ev.type] || ev.type}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

